import React from 'react';
import BubbleIcon from '../icons/bubble-icon';
import { useTSState } from '../../TSContext';
import CloseIcon from '../icons/close-icon';
const Bubble = () => {
    const { state, setStateLocal } = useTSState();
    return (React.createElement("div", { className: "ts-widget-chat-bubble", onClick: () => setStateLocal({ currentScreen: 'player', opensCount: state.opensCount + 1 }) },
        React.createElement(BubbleIcon, null),
        state.opensCount > 0 && (React.createElement("button", { onClick: () => setStateLocal({ hideBubble: true }), className: "tsplayer-icon-button", style: { position: 'absolute', top: -12, right: -12 } },
            React.createElement(CloseIcon, null)))));
};
export default Bubble;
